export const updateModalData = (data) => (dispatch) => {
  dispatch({ type: "SELECT_DATA", data });
};

export const setModalType = (modalType, header) => (dispatch) => {
  dispatch({ type: "SET_MODAL_TYPE", data: { modalType, header } });
};
